import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { BackdropSchema } from "../../fragments/Backdrop";
import { LinkItemSchema } from "../../fragments/LinkItem";
import { ImageMediaSchema } from "../../fragments/Media";
const RegionItemSchema = z.object({
    title: z.string(),
    region: z.string(),
});
export const PsRegionSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    psRegions: z.array(RegionItemSchema).optional(),
    buttons: z.array(LinkItemSchema).optional(),
});
export const PsWarningSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    buttons: z.array(LinkItemSchema).optional(),
});
export const RatingSchema = z.object({
    ratingImage: ImageMediaSchema,
    ratingText: z.string().optional(),
});
export const BetaKeyRedemptionSchema = z.object({
    xboxKeyHeader: z.string().optional(),
    psBetaKeyHeader: z.string().optional(),
    xboxRedeemButtonText: z.string().optional(),
    psRedeemButtonText: z.string().optional(),
    copySuccessText: z.string().optional(),
});
export const BetaRegistrationMastheadBladeSchema = BladeCommonSchema.extend({
    header: BladeHeaderSchema.optional(),
    backdrop: BackdropSchema.optional(),
    buttons: z.array(LinkItemSchema).optional(),
    psRegionModal: PsRegionSchema.optional(),
    psWarningModal: PsWarningSchema.optional(),
    betaKeyRedemption: BetaKeyRedemptionSchema.optional(),
    gameIcon: ImageMediaSchema.optional(),
    platformIcons: z.array(ImageMediaSchema).optional(),
    rating: RatingSchema.optional(),
    urlSuffix: z.string().optional(),
});
export const BetaRegistrationMastheadBladeTypeValues = [
    "betaRegistrationMasthead",
    "betaCenteredMasthead",
    "betaConnectConsoleMasthead",
    "betaKeyDisplayMasthead",
    "betaSuccessMasthead",
    "betaSurveyMasthead",
    "gameBetaMasthead",
];
export const BetaRegistrationMastheadBladeTypesSchema = z.enum(BetaRegistrationMastheadBladeTypeValues);
export const BetaRegistrationMastheadBladeTypes = BetaRegistrationMastheadBladeTypesSchema.enum;
export const BetaRegistrationMastheadBladesContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: BetaRegistrationMastheadBladeTypesSchema,
});
export const BetaRegistrationMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaRegistrationMasthead),
});
export const BetaCenteredMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaCenteredMasthead),
});
export const BetaConnectConsoleMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaConnectConsoleMasthead),
});
export const BetaKeyDisplayMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaKeyDisplayMasthead),
});
export const BetaSuccessMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaSuccessMasthead),
});
export const BetaSurveyMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.betaSurveyMasthead),
});
export const GameBetaMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal(BetaRegistrationMastheadBladeTypes.gameBetaMasthead),
});
//# sourceMappingURL=index.js.map